<template>
    <summary-bar class="metrics-bar"
                 root-class="metrics-bar"
                 text="Savings"
                 :flyout-open="flyoutOpen"
                 @click="$emit('click')">
        <div class="metrics-bar__summary">
            <metric-summary-item v-if="showSapMetric"
                                 class="metrics-bar__summary__sap"
                                 :metric="sapScore" />
            <template v-else>
                <metric-summary-item class="metrics-bar__summary__fuel-bill"
                                     :metric="fuelBill" />
                <metric-summary-item class="metrics-bar__summary__co2"
                                     :metric="co2" />
            </template>
        </div>
    </summary-bar>
</template>

<script>

import MetricsMultiSourceProvider from '@/components/metrics-multi-source-provider'

import MetricSummaryItem from './metric-summary-item'
import SummaryBar from './summary-bar'

export default {

    props: {
        flyoutOpen: {
            type: Boolean,
            default: false,
        },
    },

    mixins: [
        MetricsMultiSourceProvider,
    ],

    components: {
        MetricSummaryItem,
        SummaryBar,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-builder\_metrics-bar.scss

.metrics-bar {

    @include element('summary') {
        position: absolute;
        right: rem(7px);
        top: rem(6px);
        display: inline-block;
        width: 75%;
        text-align: right;

        > * {
            display: block;
            text-align: right;
            position: relative;

            &:first-child {
                top: -0.1rem;;
            }

            &:last-child {
                bottom: -0.1rem;
            }
        }

        @include bp-min-small {
            top: rem(6px);

            > * {
                display: inline-block;
                position: static;
                margin-right: 0.2rem;
                text-align: left;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
}

</style>
